import { useNavigate } from 'react-router'

interface JobsViewNavigationHook {
  navigateToList: () => void
  navigateToTask: (handlerName: string, taskId: string) => void
  navigateToHandler: (handlerName: string) => void
}

export const useJobsViewNavigation = (): JobsViewNavigationHook => {
  // Try to get the navigate function, but handle the case where we're outside Router context
  let navigate: ReturnType<typeof useNavigate> | null = null

  try {
    navigate = useNavigate()
  } catch {
    // If we're outside Router context, useNavigate will throw an error.
    navigate = null
  }

  // If we're outside Router context, use window.open to navigate.
  // TODO: Migrate to v2 tasks interface when ready.
  return {
    navigateToList: () => {
      if (navigate) {
        navigate('/admin/tasks/v2')
      } else {
        window.open('/admin/tasks', '_blank')
      }
    },
    navigateToTask: (handlerName: string, taskId: string) => {
      if (navigate) {
        navigate(`/admin/tasks/v2/${handlerName}/tasks/${taskId}`)
      } else {
        window.open(`/admin/tasks/tasks/${taskId}`, '_blank')
      }
    },
    navigateToHandler: (handlerName: string) => {
      if (navigate) {
        navigate(`/admin/tasks/v2/${handlerName}`)
      } else {
        // Do nothing. We can't navigate to a handler by name outside of the Router context.
      }
    },
  }
}
